import React from 'react'

const Footer = () => {
  return (
    <div className=' text-[#08a2d1] mt-8 font-bold flex justify-center '>Copyright © 2024 VW</div>
  )
}

export default Footer